import React from 'react';
import { injectIntl } from 'react-intl';
import { useMsal } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import SharepointFileTree from 'src/components/integracoes/microsoft/sharepoint/file-tree';
import Panel from 'src/componentes/panel';
import ConectarMicrosoft from 'src/components/integracoes/microsoft/conectar-integracao';

const SharepointSelectionModal = ({
  intl,
  selectedFile,
  onSelectFile,
  onConfirm,
  onClose,
  ...other
}) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [localSelectedFile, setLocalSelectedFile] = React.useState(
    selectedFile || {}
  );

  const handleLocalSelectFile = (file) => {
    setLocalSelectedFile(file);
    if (onSelectFile) {
      onSelectFile(file);
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(localSelectedFile);
    }
    onClose();
  };

  const actions = [
    <div key="actions">
      <Button
        key="close-sharepoint"
        color="secondary"
        leftIcon="close"
        onClick={onClose}
      >
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>

      <Button
        key="confirm-sharepoint"
        className="ml-2"
        leftIcon="check"
        onClick={handleConfirm}
        disabled={!localSelectedFile?.filePath}
      >
        {intl.formatMessage({ id: 'label.confirmar' })}
      </Button>
    </div>,
  ];

  return (
    <Dialog
      {...other}
      title={intl.formatMessage({ id: 'label.anexarArquivosSharepoint' })}
      actions={actions}
      padContent
      onRequestClose={onClose}
      style={{ minWidth: '40rem', maxHeight: '80vh' }}
    >
      {isAuthenticated && instance.getActiveAccount() !== null ? (
        <Panel>
          <span className="text-muted font-weight-bolder">
            {intl.formatMessage({ id: 'selecioneArquivo' })}:
          </span>
          {localSelectedFile?.filePath && (
            <div className="d-flex mt-3 flex-column">
              <span>
                {intl.formatMessage({ id: 'ultimoArquivoSelecionado' })}:
              </span>
              <div
                className="mt-1 py-2 px-3 rounded-lg"
                style={{ backgroundColor: '#2377881A' }}
              >
                <span className="font-weight-bold">
                  {localSelectedFile?.filePath}
                </span>
              </div>
            </div>
          )}
          <SharepointFileTree
            selectedFile={localSelectedFile}
            onSelectFile={handleLocalSelectFile}
          />
        </Panel>
      ) : (
        <ConectarMicrosoft />
      )}
    </Dialog>
  );
};

export default injectIntl(SharepointSelectionModal);
